import React, { useEffect, useMemo, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
	getPromoFaqsAdmin,
	deletePromoFaq,
	movePromoFaq,
} from "../../../../api/promo-faq";
import {
	Button,
	Tooltip,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import { buttonsStyle } from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

function previewQuestion(faq) {
	return String(faq?.locales?.es?.question || faq?.locales?.en?.question || "").trim() || "(Sin pregunta)";
}

export default function PromoFaqsPage() {
	const [faqs, setFaqs] = useState([]);
	const [faqId, setFaqId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [movingId, setMovingId] = useState(null);
	const history = useHistory();

	const sorted = useMemo(
		() =>
			[...(faqs || [])].sort(
				(a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || String(a._id).localeCompare(String(b._id))
			),
		[faqs]
	);

	useEffect(() => {
		let mounted = true;
		getPromoFaqsAdmin()
			.then((res) => {
				if (!mounted) return;
				if (res.status === 200) setFaqs(res.data || []);
			})
			.catch((error) => {
				if (!mounted) return;
				alertError({ error, customMessage: "No se pudieron cargar las FAQs." });
			})
			.finally(() => {
				if (mounted) setRefresh(false);
			});
		return () => {
			mounted = false;
		};
	}, [refresh]);

	const handleMove = (id, direction) => {
		setMovingId(id);
		movePromoFaq(id, direction)
			.then((res) => {
				if (res.status === 200) setRefresh(true);
			})
			.catch((error) => {
				alertError({ error, customMessage: "No se pudo cambiar el orden." });
			})
			.finally(() => setMovingId(null));
	};

	return (
		<>
			<Card>
				<CardHeader title="FAQs web (precios)">
					<CardHeaderToolbar>
						<Button
							variant="contained"
							color="primary"
							onClick={() => history.push("/edit-promo-faq")}
						>
							Nueva FAQ
						</Button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					{sorted.length === 0 ? (
						<Typography color="textSecondary">
							No hay FAQs. Se crearán automáticamente las de precios al acceder por primera vez, o puedes añadir una nueva.
						</Typography>
					) : (
						<TableContainer component={Paper} variant="outlined">
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Pregunta (ES)</TableCell>
										<TableCell width={100}>Estado</TableCell>
										<TableCell width={200} align="right">
											Acciones
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{sorted.map((faq, index) => {
										const id = faq._id;
										const isFirst = index === 0;
										const isLast = index === sorted.length - 1;
										const active = faq.active !== false;
										return (
											<TableRow key={id}>
												<TableCell>{previewQuestion(faq)}</TableCell>
												<TableCell>
													{active ? (
														<Chip label="Activa" size="small" style={{ background: "#1bc5bd", color: "#fff" }} />
													) : (
														<Chip label="Inactiva" size="small" />
													)}
												</TableCell>
												<TableCell align="right">
													<Tooltip title="Editar">
														<Button
															size="small"
															style={buttonsStyle}
															onClick={() => history.push("/edit-promo-faq/" + id)}
														>
															<EditIcon />
														</Button>
													</Tooltip>
													<Tooltip title="Eliminar">
														<Button
															size="small"
															style={buttonsStyle}
															onClick={() => {
																setFaqId(id);
																setOpenConfirmDialog(true);
															}}
														>
															<DeleteIcon />
														</Button>
													</Tooltip>
													<Tooltip title="Subir">
														<span>
															<Button
																size="small"
																style={buttonsStyle}
																disabled={isFirst || movingId === id}
																onClick={() => handleMove(id, "up")}
															>
																<ArrowUpwardIcon fontSize="small" />
															</Button>
														</span>
													</Tooltip>
													<Tooltip title="Bajar">
														<span>
															<Button
																size="small"
																style={buttonsStyle}
																disabled={isLast || movingId === id}
																onClick={() => handleMove(id, "down")}
															>
																<ArrowDownwardIcon fontSize="small" />
															</Button>
														</span>
													</Tooltip>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
					)}
					<ConfirmDialog
						title="¿Seguro que quieres eliminar esta FAQ?"
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deletePromoFaq(faqId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({ title: "Eliminada", customMessage: "FAQ eliminada correctamente." });
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error, customMessage: "No se pudo eliminar la FAQ." });
								})
								.finally(() => {
									setOpenConfirmDialog(false);
									setFaqId(null);
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
